/**
 * Microsoft scope constants. Import-free on purpose: the browser's Connect calendar hook reads
 * them, and `src/lib/microsoft-sign-in.ts` (better-auth/oauth2) must not be bundled client-side.
 */

/** What "Connect calendar" asks for on top of sign-in (incremental consent, spec § Data). */
export const CALENDAR_SCOPES = [
  "offline_access",
  "https://graph.microsoft.com/Calendars.Read",
] as const;

export const SIGN_IN_SCOPES = ["openid", "profile", "email"] as const;
